import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Plus, MessageSquare } from 'lucide-react';
import employeeApi from '../../lib/employeeApi';
import EmployeeLayout from '../../components/EmployeeLayout';
import { SearchableSelect } from '../../components/ui/searchable-select';

export default function HelpDeskPage() {
  const [tickets, setTickets] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ ticket_type: 'help_request', subject: '', description: '', priority: 'medium' });

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    try {
      const res = await employeeApi.get('/api/employee/tickets');
      setTickets(res.data);
    } catch (error) {
      toast.error('Failed');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await employeeApi.post('/api/employee/tickets', formData);
      toast.success('Ticket created');
      setShowForm(false);
      fetchTickets();
    } catch (error) {
      toast.error('Failed');
    }
  };

  return (
    <EmployeeLayout>
      <div className="p-8">
        <div className="flex justify-between mb-6">
          <h1 className="text-2xl font-bold text-navy-900">Help Desk</h1>
          <button onClick={() => setShowForm(!showForm)} className="px-6 py-2 bg-purple-500 text-white rounded-xl hover:bg-purple-600"><Plus className="w-5 h-5 inline mr-2" />Create Ticket</button>
        </div>
        {showForm && (
          <div className="bg-white rounded-xl border p-6 mb-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <SearchableSelect value={formData.ticket_type} onChange={(v) => setFormData({ ...formData, ticket_type: v })} triggerClassName="rounded-xl" options={[{ value: 'help_request', label: 'Help Request' }, { value: 'complaint', label: 'Complaint' }, { value: 'escalation', label: 'Escalation' }]} data-testid="helpdesk-ticket-type" />
                <SearchableSelect value={formData.priority} onChange={(v) => setFormData({ ...formData, priority: v })} triggerClassName="rounded-xl" options={[{ value: 'low', label: 'Low' }, { value: 'medium', label: 'Medium' }, { value: 'high', label: 'High' }]} data-testid="helpdesk-priority" />
              </div>
              <input type="text" required value={formData.subject} onChange={(e) => setFormData({ ...formData, subject: e.target.value })} placeholder="Subject" className="w-full px-4 py-2 border rounded-xl" />
              <textarea required value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows={5} placeholder="Description" className="w-full px-4 py-2 border rounded-xl" />
              <div className="flex gap-3"><button type="button" onClick={() => setShowForm(false)} className="flex-1 px-6 py-2 bg-neutral-100 rounded-xl">Cancel</button><button type="submit" className="flex-1 px-6 py-2 bg-purple-500 text-white rounded-xl">Create</button></div>
            </form>
          </div>
        )}
        <div className="space-y-4">
          {tickets.map((ticket) => (
            <div key={ticket._id} className="bg-white rounded-xl border p-6">
              <div className="flex justify-between items-start mb-3">
                <div><h3 className="font-semibold text-navy-900">{ticket.subject}</h3><p className="text-sm text-neutral-600">{ticket.type} • {ticket.priority}</p></div>
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${ticket.status === 'open' ? 'bg-amber-100 text-amber-800' : ticket.status === 'resolved' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>{ticket.status}</span>
              </div>
              <p className="text-sm text-neutral-700">{ticket.description}</p>
            </div>
          ))}
        </div>
      </div>
    </EmployeeLayout>
  );
}